import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { ModalController } from '@ionic/angular';

@Component({
  selector: 'app-privacy',
  templateUrl: './privacy.component.html',
  styleUrls: ['./privacy.component.scss'],
})
export class PrivacyComponent implements OnInit {

  constructor(public router: Router,
    public modalController: ModalController) { }

  ngOnInit() {}

  dismiss(): void {
    this.modalController.dismiss();
  }

}
